import { IMenuOption } from "../../shared/components/NewMenu/useMenuOptions";
import { MyFilesIcon } from "../../shared/icons";

export const myResourcesOptions: IMenuOption[] = [
  {
    disabled: false,
    divider: false,
    Icon: <MyFilesIcon />,
    path: "/vault",
    menu: "account",
    onClick: null,
    text: "My Files",
  },
];
